import React, { useState } from 'react'
import {ChevronDownIcon, XCircleIcon} from '@heroicons/react/16/solid'
import {Button} from './button'


export interface SelectProps
    extends React.InputHTMLAttributes<HTMLSelectElement> {
    asChild?: boolean
    options?: {
        id: number,
        name: string,
        description?: string,
    }[],
    trailingIcon?: React.ReactNode
    setNewGroupIsOpen: (value: boolean) => void
    newGroupIsOpen: boolean,
    // status?: 'success' | 'error'
}

const GroupSelect = React.forwardRef<HTMLSelectElement, SelectProps> (
    ({ className, asChild, options, value, onChange, setNewGroupIsOpen,newGroupIsOpen,  ...props }) => {
        const { } = props
        const [isOpen, setIsOpen] = useState(false)

        // const formType = useWatch({ control:control, name:'vault_group.id' })

        return (
            <div className="relative ">
                <div
                    className={`flex justify-between border border-gray-300 rounded-md h-12 p-4 text-sm items-center focus-within:!shadow-input-focus hover:shadow-input-hover active:shadow-input-focus focus:outline-none focus:shadow-outline  ${
                        value ? 'text-black' : 'text-txt-secondary'
                    }`}
                >
                    {newGroupIsOpen ? 'Create new group' : (options?.find((option) => option.id === Number(value))?.name || 'Select a group for the vault')}

                    {value ? (
                        <div className='flex'>
                            <Button variant='ghost'
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        onChange('')
                                        setNewGroupIsOpen(false)
                                    }}>
                                <XCircleIcon className='size-4 text-txt-secondary'/>
                            </Button>
                            <Button
                                variant='ghost'
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                <ChevronDownIcon className='size-4 text-txt-secondary'/>
                            </Button>

                        </div>
                    ) : (
                        <Button
                            variant='ghost'
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            <ChevronDownIcon
                                className='size-4 text-txt-secondary'/>
                        </Button>
                    )}

                </div>
                {isOpen && (
                    <div className="absolute bottom-full mb-2 text-sm mt-1 bg-white border border-gray-300 rounded-md w-full shadow-lg z-10">
                        <div
                            className="px-2 py-3 hover:bg-gray-100 cursor-pointer border-b"
                            onClick={() => {
                                onChange('')
                                setNewGroupIsOpen(true)
                                setIsOpen(false)
                            }}
                        >
                            Create new group
                        </div>
                        {options ? (
                            <div className=' max-h-48 overflow-y-auto'>
                                {options.map((option, index) => (
                                    <div
                                        key={index}
                                        className="p-2 hover:bg-gray-100 cursor-pointer flex flex-col max-h-48 overflow-y-auto"
                                        onClick={() => {
                                            onChange(option.id)
                                            setIsOpen(false)
                                            setNewGroupIsOpen(false)
                                        }}
                                    >
                                        <span className="font-medium">{option.name}</span>
                                        {option.description && (
                                            <span className="text-xs text-gray-500">{option.description}</span>
                                        )}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="p-2 text-txt-secondary">No items available</div>

                        )}

                    </div>
                )}
            </div>

        )
    })
GroupSelect.displayName = 'Select'

export {GroupSelect}
